import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63551a8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "myreward" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "myreward-title" }, "收益試算", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "myreward-subtitle" }, "實際收益以通告核實後總額為準", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "myreward-subtitle myreward-subtitle--right" }, "*單位：新台幣", -1))
const _hoisted_5 = { class: "myreward-foot" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看詳細收益紀錄 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RewardVue = _resolveComponent("RewardVue")!
  const _component_right_outlined = _resolveComponent("right-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_RewardVue, {
      title: "本月收益",
      reward: _ctx.rewardsThisMonth,
      expand: true
    }, null, 8, ["reward"]),
    _createVNode(_component_RewardVue, {
      title: "上月收益",
      reward: _ctx.rewardsLastMonth
    }, null, 8, ["reward"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, { to: { name: 'Rewards' } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, { shape: "round" }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createVNode(_component_right_outlined)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}